import { Component, OnInit, Input } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, Message } from 'primeng/api';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
	selector: 'app-document-upload',
	templateUrl: './document-upload.component.html'
})
export class DocumentUploadComponent implements OnInit {
	@Input() docNo: string;
	@Input() tableId: number;
	@Input() uploadUrl: string;

	messages: Message[] = [];

	constructor(
		private configService: ConfigService,
		private dialogRef: DynamicDialogRef,
		private authService: AuthenticationService,
		private config: DynamicDialogConfig
	) {}

	clearMessages() {
		this.messages.length = 0;
	}

	setMessage(msg: Message) {
		this.clearMessages();
		this.messages.push(msg);
	}

	ngOnInit() {
		this.docNo = this.config.data !== undefined ? this.config.data.docNo : undefined;
		this.tableId = this.config.data !== undefined ? this.config.data.tableId : undefined;
		this.uploadUrl = this.config.data !== undefined ? this.config.data.uploadUrl : undefined;

		if (this.docNo === undefined || this.uploadUrl === undefined || this.tableId === undefined) {
			this.closeDialog(undefined);
		}
	}

	showView() {
		return this.docNo !== undefined && this.uploadUrl !== undefined && this.tableId !== undefined;
	}

	beforeUpload(event: { xhr: XMLHttpRequest; formData: FormData }) {
		event.formData.append('DocNo', this.docNo);
		event.formData.append('TableId', this.tableId.toString());
	}

	beforeSend(event: { xhr: XMLHttpRequest; formData: FormData }) {
		event.xhr.setRequestHeader('Authorization', 'Bearer ' + this.authService.getAccessToken());
	}

	afterUpload(event: { xhr: XMLHttpRequest; files: [] }) {
		const response = JSON.parse(event.xhr.response);

		this.closeDialog(response);
	}

	handleError(event: { xhr: XMLHttpRequest; files: [] }) {
		if (''.concat(event.xhr.response).length > 1) {
			const error = JSON.parse(event.xhr.response);
			if ('errorMessage' in error) {
				this.setMessage({
					severity: 'error',
					detail: error['errorMessage']
				});
			}
		} else {
			this.setMessage({
				severity: 'error',
				detail: event.xhr.statusText
			});
		}
	}

	closeDialog(result: any) {
		this.dialogRef.close(result);
	}
}
